export enum ResponseTypes {
    info = 'INFO',
    error = 'ERROR',
    success = 'SUCCESS',
    warning = 'WARNING',
}
